<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data pelunasan."
            @click="save()"
            :disabled="savedisabled"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data pelunasan."
            @click="save()"
            :disabled="savedisabled"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                  @keyup.13.native="lkuPinjamanShow = true"
                  :state="!$v.frmdt.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tgl_kontrak"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_agreement" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5" style="display: flex;justify-content: left;align-items: center;">
              <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.pinjaman_uraian"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB'">
                <label style="width: 140px">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width: 140px">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman == 'PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="0"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB'">
              <b-input-group-prepend>
                <label style="width: 140px">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
        <b-card align="center" no-body>
            <b-table
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;"
              :items="tblDataMemo.items"
              :fields="tblFieldsMemo"
              :current-page="tblDataMemo.page"
              :per-page="tblDataMemo.limit"
              :sort-by.sync="tblDataMemo.sortBy"
              :sort-desc.sync="tblDataMemo.sortDesc"
              :key="tblDataMemo.limit"
              show-empty
                caption-top
            >
                <template #table-caption style="margin-top:0px;"><h5>History Memo Pelunasan</h5></template>
              <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
              <template v-slot:cell(CustCode)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
              <template
                v-slot:cell(tglsurat)="data"
              >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
              <template
                v-slot:cell(tgl_kontrak)="data"
              >{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
              <template
                v-slot:cell(tglpelunasan)="data"
              >{{ data.item.tglmulaipelunasan | moment("DD MMM YYYY") }} - {{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template>
              <template v-slot:cell(ttlpayment_awal)="data">{{ data.item.ttlpayment_awal | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttllatecharge)="data">{{ data.item.ttllatecharge | numFormat('0,0.00') }}</template>
              <template v-slot:cell(diskon_amount)="data">{{ data.item.diskon_amount | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttlmustpay)="data">{{ data.item.ttlmustpay | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttlpayment_diskon)="data">{{ data.item.ttlpayment_diskon | numFormat('0,0.00') }}</template>
              <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{ data.item.CONTRACT_PREPAID_AMT | numFormat('0,0.00') }}</template>
              <template v-slot:cell(wo_status)="data">{{ data.item.wo_status==1?'WO':'Normal'}}</template>

              <template
                v-slot:cell(status_memo)="data"
              >
                <span v-if="data.item.isreject==1">Rejected</span>
                <span v-else-if="data.item.issuccess==1">Approved</span>
                <span v-else-if="data.item.send2wf==1">Send Approval</span>
                <span v-else-if="data.item.isexpired==1">Expired</span>
                <span v-else-if="data.item.ispaid==1">PAID ({{data.item.paid_date | moment('DD-MM-YYYY')}})</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(modified_by)="data">{{ data.item.modified_by ? data.item.modified_by : '-'}}</template>
              
              <template v-slot:cell(action)="data">
                <a :href="viewdetailmemo(data.item.pelunasankey)" target="_blank"><i class="fa fa-eye"></i> View Detail</a>
                <!-- <a @click="viewdetailmemo(data.item.pelunasankey)" target="_blank"><i class="fa fa-eye"></i> View Detail</a> -->
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing {{(tblDataMemo.page - 1) * tblDataMemo.limit + 1}}
                  to
                  <span
                    v-if="((tblDataMemo.page * tblDataMemo.limit)>tblDataMemo.total)"
                  >{{tblDataMemo.total}}</span>
                  <span v-else>{{tblDataMemo.page * tblDataMemo.limit}}</span>
                  of {{tblDataMemo.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label-cols="3" label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblDataMemo.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataMemo.total"
                  :per-page="tblDataMemo.limit"
                  v-model="tblDataMemo.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        <hr/>
       <b-row>
            <b-col lg="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jenis Pelunasan</label>
                  </b-input-group-prepend>
                  <b-form-checkbox-group
                        id="checkbox-group-2"
                        v-model="frmdt.tipepelunasan"
                        :state="!$v.frmdt.tipepelunasan.$error"
                        class="pt-6 "
                    >
                        <b-form-checkbox value="Normal">Normal</b-form-checkbox>
                        <b-form-checkbox value="Bertahap">Bertahap</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend>
                        <label>Action</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="frmdt.isblocked" 
                    :state="!$v.frmdt.isblocked.$error"
                    :options="optionsAction" 
                    class="mb-3">
                    </b-form-select>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend>
                        <label>Kronologis</label>
                    </b-input-group-prepend>
                    <b-form-textarea
                        v-model="frmdt.note"
                        :state="!$v.frmdt.note.$error"
                        placeholder=""
                        rows="5"
                        max-rows="10"
                    ></b-form-textarea>
                </b-input-group>
            </b-col>
        </b-row>        
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjamanSimple";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import asset from "../../apis/agunankredit";
import releasedoc from "../../apis/releasedoc";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required,minValue } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      pinjamankey: { required },
      tipepelunasan: { required },
      isblocked:{ required },
      note:{ required }
    },
  },
  data() {
    return {
      savedisabled:false,
      showReport: false,
      reportUrl: null,
      isLoading: false,
      isBusytblDataAsset:false,
      model: {},
      frmdt: {
          tableKey:'',
          pinjamankey:'',
          tipepelunasan:[],
          isblocked:1,
          note:''
        },
        optionsAction:[
          { value: "", text: 'Please select an option',disabled: true  },
          { value: 1, text: 'Block'},
          { value: 0, text: 'Allow'}
        ],
      tblDataMemo: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",nosurat:""
      },
      lkuPinjamanShow: false,
      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
      documentSelected: []
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      return this.$v.frmdt.$invalid;
    },
    tblFieldsMemo() {
      const fields = [
         {
          key: "tglsurat",
          label: "Tgl. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF | Debitur Name",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
         {
          key: "tipepelunasan",
          label: "Jenis Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tglpelunasan",
          label: "Tgl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttlpayment_awal",
          label: "Sisa Pinjaman / Angsuran",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "ttlpayment_diskon",
          label: "Ttl. Diskon",
          thStyle: "width:140px",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CONTRACT_PREPAID_AMT",
          label: "Ttl. Prepaid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "ttlmustpay",
          label: "Ttl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
  },
  watch: {
  },
  created: async function () {
    if (this.$route.params.tableKey) {
      toastr.info("Loading Detail, please wait");
      try {
        const res = await pelunasan.detailblacklist(this.$route.params.tableKey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }
        this.frmdt.tipepelunasan= res.tipepelunasan.split(",");
        this.getMemo();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }   

    const {finalOwner} = await pelunasan.getworkflowblacklist();
    if(finalOwner){
      let finalOwnerArr = finalOwner.split(',');
      let findLastFinal =  finalOwnerArr[finalOwnerArr.length-1];
      let user = this.$store.state.user;
      if((findLastFinal.split('|')).find(x=>x==user.username)){
        this.savedisabled= false;
      }else{
        this.savedisabled= true;
        toastr.warn("Anda tidak diberikan hak untuk merubah data.", "INFO MESSAGE");
      }
    }else{
      this.savedisabled= true;
      toastr.warn("Anda tidak diberikan hak untuk merubah data.", "INFO MESSAGE");
    }
    
  },
  methods: {
      onRowSelected(items) {
        this.documentSelected = items
      },
      selectAllRows() {
        this.$refs.table.selectAllRows()
      },
      clearSelected() {
        this.$refs.table.clearSelected()
      },

    async onSelectLkuPinjaman(_selected) {
      let find = await pelunasan.detailblacklistbypinjamankey(_selected.pinjamankey);
      if(find){
        toastr.warn(`Pinjaman sudah ada dalam daftar black list`, "INFO","5000");
        const res = await pelunasan.detailblacklist(find.tableKey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }
        this.frmdt.tipepelunasan= res.tipepelunasan.split(",");
        this.getMemo();
        toastr.clear;

      }else{
        this.frmdt.pinjamankey = _selected.pinjamankey;
        this.frmdt.nasabahkey = _selected.nasabahkey;
        for (const key in _selected) {
          this.model[key] = _selected[key];
        }
        this.model.tgl_kontrak = _selected.tgl_kontrak
          ? moment(_selected.tgl_kontrak).format("DD-MM-YYYY")
          : "";
        this.model.pinjaman_uraian = _selected.uraian;
        this.model.ttllatecharge = 0;
      }
      
      this.lkuPinjamanShow = false;
      this.getMemo();
    },
    async getMemo(){
      try {
        this.isLoading=true;
        const list = await pelunasan.getMemoPinjaman(this.frmdt.pinjamankey);
        this.tblDataMemo.items=list;
        this.tblDataMemo.total = list.length;    
        this.isLoading=false; 
        //return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    tooglePrintSave(param) {
      if (!param) {
        this.printPelunasanpdf();
      } else {
        this.simpanCetak();
      }
    },
    async simpanCetak() {
      if (this.invalidFrmDt) {
        // console.log("validation : ", this.$v.model);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if (this.frmdt.ttlpayment == 0) {
          this.stateTtlPay = false;
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          //disini cek api dulu, apakah nomor surat memo pelunasan sudah pernah ada sebelumnya!
          const dataNomorMemo = await pelunasan.ceknomorMemo(this.frmdt);
          if(!this.$route.params.pelunasankey && dataNomorMemo){
            toastr.warn(`Memo pelunasan dengan nomor surat: ${dataNomorMemo.nosurat} sudah pernah dibuat sebelumnya. Silahkan cek kembali nomor surat!`, "INFO","8000");
          }else{
            const pelunasankey = await pelunasan.save(this.frmdt);
            this.frmdt.pelunasankey = pelunasankey;
            toastr.success("Data berhasil disimpan");
            this.printPelunasanpdf();
            router.push({ name: "loan.pelunasan" });
          }
        }
      }
    },
    close() {
      router.push({ name: "loan.memopelunasanblacklist" });
    },
    async save() {
      if (this.invalidFrmDt) {
        console.log("validation : ", this.$v.frmdt);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
            const data = await pelunasan.saveblacklist(this.frmdt);
            this.frmdt.releaseKey = data.releaseKey;
            toastr.success("Data berhasil disimpan");
            router.push({ name: "loan.memopelunasanblacklist" });
        
      }
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
    viewdetailmemo(pelunasankey){
      const url = router.resolve({name:'loan.pelunasanmemoview',params:{pelunasankey}}).route.path;
      return `#`+url;
    },
  },
};
</script>
